import { nanoid } from "nanoid"

const framesType = {

    collection: {
        key: "{{_id}}",
        section: 'collections',
        pageType: 'collection',
        fetchUrl: 'getRecords',
        addUrl: 'postFrame',
        editUrl: 'postFrame',
        removeUrl: 'removeFrame',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },
    messenger: {
        key: "{{_id}}",
        section: 'messengers',
        pageType: 'messenger',
        fetchUrl: 'getRecords',
        addUrl: 'postFrame',
        editUrl: 'postFrame',
        removeUrl: 'removeFrame',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },
    folder: {
        key: "{{_id}}",
        section: 'collections',
        pageType: 'collection',
        fetchUrl: 'getRecords',
        addUrl: 'postFolder',
        editUrl: 'postFolder',
        removeUrl: 'removeFolder',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },
    project: {
        key: "{{_id}}",
        section: 'collections',
        pageType: 'collection',
        addUrl: 'postProject',
        editUrl: 'postProject',
        removeUrl: 'removeProject',
        postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
    },


   


}




export { framesType }